import React from 'react';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery'
import { useStyles } from "../styles/styles";
import { getDecimal } from "../global/utils";
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";
import Tooltip from '@mui/material/Tooltip';
import InstallmentList from "./InstallmentList";
import Zoom from "@mui/material/Zoom";

const PlanList = (props) => {
    const plans = props.plans;
    const selectPlan = props.selectPlan;
    const listTitle = props.listTitle;
    const theme = useTheme();
    const tiny = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles;

    return (
        <>
            <Typography variant='h6' component='h2' color='primary' sx={{...classes.title, fontSize: '1.2rem', marginTop: '0.2rem', marginBottom: '.5rem'}}>{listTitle ? listTitle : 'Payment Plans'}</Typography>
            <Paper elevation={3} sx={classes.listContainer}>
                <List sx={classes.list} >
                    {plans && plans.filter(plan => !plan.selected).map((plan, idx, shown) => {
                        // The rule is the item's own bottom border (divider), not a sibling
                        // <Divider/>: a <ul> may only contain <li>, so a bare <hr> there is
                        // invalid list markup (CPDEV-2827). None under the last plan shown;
                        // the box edge already separates it from the balances below.
                        return (
                            <ListItem key={plan.planId} divider={idx < shown.length - 1} alignItems='flex-start' sx={classes.listPadding}>
                                <ListItemText
                                    sx={classes.listText}
                                    primary={
                                        <Grid
                                            container
                                            spacing={2}
                                            style={{width: '100%'}}
                                            sx={{
                                                alignItems: "top"
                                            }}
                                        >
                                            <Grid
                                                size={{
                                                    xs: 3,
                                                    lg: 2
                                                }}>
                                                {/* Named for its plan, as BalanceList's are for their case; left to the
                                                    Tooltip, every plan's button was "Add plan to the payment list". */}
                                                <Tooltip title='Add plan to the payment list' slots={{transition: Zoom}} arrow>
                                                    { tiny ?
                                                        <Button color="success" onClick={() => selectPlan(plan)} sx={{padding: '0'}} aria-label={`Add to Cart ${plan.planDescription}`}>
                                                            Add to Cart
                                                        </Button> :
                                                        <Button variant='contained' color='success' onClick={() => selectPlan(plan)} sx={{...classes.tinyButton, fontSize: {xs: '.65rem', md: '.7rem'}, whiteSpace: 'nowrap', padding: '0 .3rem'}} aria-label={`Add to Cart ${plan.planDescription}`}>
                                                            Add to Cart
                                                        </Button>
                                                    }
                                                </Tooltip>
                                            </Grid>
                                            <Grid
                                                size={{
                                                    xs: 9,
                                                    lg: 5
                                                }}>
                                                {plan.planDescription}
                                            </Grid>
                                            <Grid
                                                size={{
                                                    xs: 12,
                                                    lg: 5
                                                }}>
                                                <Typography component='span' variant='subtitle2' color='secondary' >
                                                    Select one or more installments to pay
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    }
                                    slotProps={{
                                        // div, not span/p: both slots hold block content
                                        // (Grid containers, the installment table).
                                        primary: {
                                            component: 'div',
                                            variant: 'subtitle2',
                                            color: 'textPrimary'
                                        },
                                        secondary: {
                                            component: 'div',
                                            variant: 'body2',
                                            color: 'textPrimary'
                                        }
                                    }}
                                    secondary={ plan.installments &&
                                        <>
                                            <Grid
                                                container
                                                spacing={2}
                                                sx={{
                                                    alignItems: "top"
                                                }}
                                            >
                                                <Grid size={12}>
                                                    <InstallmentList installments={plan.installments} />
                                                </Grid>
                                            </Grid>
                                            { plan.planPaymentServiceFee && plan.planPaymentServiceFee > 0 &&
                                                <Grid style={{paddingTop: '0'}} size={12}>
                                                    <Typography color='secondary'>
                                                        A payment plan service fee of ${getDecimal(plan.planPaymentServiceFee)} will be added.
                                                    </Typography>
                                                </Grid>
                                            }
                                        </>
                                    }
                                />
                            </ListItem>);
                    })}
                </List>
            </Paper>
        </>
    );
}

export default PlanList;